import {
	getOrgDetails,
	getOrgMyRole,
	getOrgMyPositions,
} from '../actions/orgActions'
import { setOrgDetails, setOrgRole, setUserPositions } from '../store/orgSlice'

export const loadOrgContext = async (orgSlug, dispatch) => {
	try {
		if (!orgSlug) return

		const org = await getOrgDetails(orgSlug)
		dispatch(setOrgDetails(org))

		const orgRole = await getOrgMyRole(orgSlug)
		dispatch(setOrgRole(orgRole.role))

		const userPositions = await getOrgMyPositions(orgSlug)
		dispatch(setUserPositions(userPositions))
	} catch (err) {
		console.error('❌ Failed to load org context:', err)
	}
}
